import { FaTimesCircle } from "react-icons/fa"; // Import X icon
import "../App.css"; // Import the CSS file

const AccountLockedMessage = () => {
    return (
        <div className="error-message">
            <FaTimesCircle className="error-icon" />
            <span>
                Too many failed login attempts! <br />
                For security reasons, your account has been locked. Please reach out to the admin 
                <a
                    href="https://www.youtube.com/channel/UCMJeoG6jGrGtk3noLZ6bJMg?sub_confirmation=1"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'blue', fontWeight: 'bold', marginLeft: '5px' }}
                >
                    over here
                </a> for assistance.
            </span>
        </div>
    );
};

export default AccountLockedMessage;
